"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProratedPriceResponseMapper = void 0;
var ProratedPriceResponseMapper = /** @class */ (function () {
    function ProratedPriceResponseMapper(data) {
        this.localData = data;
    }
    ProratedPriceResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return ProratedPriceResponseMapper;
}());
exports.ProratedPriceResponseMapper = ProratedPriceResponseMapper;
//# sourceMappingURL=ProratedPriceResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/ProratedPriceResponseMapper.js
// module id = 2079
// module chunks = 8